<div class="card">
  <div class="col-12">
      <div class="card-header customSmallHeader   rounded-0 fw-bold d-flex">
        <div class="col-4">
          <i class="fa fa-info me-2"></i> Terms of Use:
        </div>
      </div>
      <div class="card-body row">

        <p class="control-label">
          ‘Welcome to Quotator website (the “Website”) at https://quotator360.com and thank you for
          visiting us. This Website is owned and controlled by Munich Re Underwriting Agents (DIFC)
          Limited (‘MRUA’), and MRUA will retain all interest in and to the Software, including all
          documentation, modifications,
          improvements, upgrades, derivative words, and all other Intellectual Property rights in connection
          with the Software,
          including MRUA's (and affiliates) name, logos. and trademarks reproduced through the Service.
        </p>
      </div>
      <div class="card-body row">
        <div>
          <p class="control-label">
            By choosing to access or use this Website, you are agreeing to abide by all
            of the terms and
            conditions of these Terms of Use
          </p>
        </div>
        <div>
          <ul>
            <ol>
              <li>
                <p>
                  You represent and warrant that you are an employee of an insurance company / brokerage
                  that is approved to make use of this service.
                </p>
              </li>
              <li>
                <p>
                  You consent to your name and email address being used by quotator360.com in order to
                  provide access to the website.
                </p>
              </li>
              <li>
                <p>
                  You agree not to share your login credentials with any third party individual or
                  colleague.
                </p>
              </li>
              <li>
                <p>
                  You understand that MRUA will retain exclusive interest in and ownership of
                  quotator360.com
                </p>
              </li>
              <li>
                <p>
                  MRUA must be contacted if the quote generated is not in line with standard
                  underwriting practices or you believe there has been an error with the quotation
                  provided
                </p>
              </li>
              <!-- <li>
                  <p>Modification of TOB - Terms</p>
              </li> -->
              <li>
                <p>
                  MRUA may maintain and use the data input via the tool, which will be retained in line
                  with Munich Re Group’s data protection requirements
                </p>
              </li>
              <li>
                <p>
                  MRUA may change, add or remove portions of these Terms of Use at any time at our sole
                  discretion, which changes shall become effective immediately upon posting. It is
                  your responsibility to review these Terms of Use prior to each use of the Website
                  and by continuing to use this Website, you agree to any changes
                </p>
              </li>
            </ol>
          </ul>
        </div>
      </div>
    </div>
  </div>
